export const download = (nmArquivo: string, bytesDocumento: string): void => {
  const byteCharacters = atob(bytesDocumento);

  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type: 'application/octet-stream',
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nmArquivo;
  a.click();
  window.URL.revokeObjectURL(url);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const downloadFile = (file: any, filename: string) => {
  const blob = new Blob([file.data], { type: 'application/pdf' });
  //@ts-expect-error: a nova versão do typescript não tem o msSaveOrOpenBlob como parte do type do Navigator
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // for IE
    //@ts-expect-error: a nova versão do typescript não tem o msSaveOrOpenBlob como parte do type do Navigator
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  }
};
